import './polyfills';
import './index.css';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {initRum} from './app/rum';
import {V3QueryProvider} from '@v3/api/queryClient';
import {App} from './App';
import {App as AppV3} from '@v3/App';

initRum();

const root = createRoot(document.getElementById('root')!);

root.render(
	<V3QueryProvider>
		<BrowserRouter future={{v7_relativeSplatPath: true, v7_startTransition: true}}>
			{import.meta.env.VITE_FF_UI_V3 === 'true' ? <AppV3/> : <App/>}
		</BrowserRouter>
	</V3QueryProvider>
);
